
import { Course } from '../types';

export const c100_application: Course = {
  id: "c100_application",
  title: "The C100 Application: Your Opening Move",
  description: "Master the first formal step of the court process. Learn how to draft your application, manage safeguarding concerns, and use the online portal.",
  icon: "📑",
  totalModules: 15,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    15: { id: 15, title: "Slide 15", slides: [{ title: "Slide 15", content: `<div class="flex justify-center"><img src="/images/courses/c100_application/Slide15.PNG" alt="Slide 15" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is a mandatory prerequisite that must be completed before filing a C100 application?",
        "o": [
            "Filing Form C1A",
            "Attending a Mediation Information and Assessment Meeting (MIAM)",
            "Personally serving papers to the other parent",
            "Paying a £1000 filing fee"
        ],
        "a": 1
    },
    {
        "q": "According to the course slides, what is the recommended approach for the C100 application's summary?",
        "o": [
            "A detailed argument of 1,000 emotional words",
            "A summary of approximately 200 factual words, focusing on 'what'",
            "An emotional storytelling approach",
            "A summary that includes all detailed 'how' explanations"
        ],
        "a": 1
    },
    {
        "q": "What is the primary purpose of Form C1A (Safeguarding Supplement)?",
        "o": [
            "To request a Specific Issue Order",
            "To apply for financial assistance with court fees",
            "To document genuine allegations of harm and respond to allegations made against you",
            "To personally serve court papers to the other parent"
        ],
        "a": 2
    },
    {
        "q": "What is the standard filing fee for a C100 application, and which form is used for financial assistance?",
        "o": [
            "£100, Form C1A",
            "£255, Form EX160",
            "£500, no assistance available",
            "No fee, Form MIAM"
        ],
        "a": 1
    },
    {
        "q": "Who is responsible for formally serving court papers to the other parent?",
        "o": [
            "The applicant directly",
            "The applicant's immediate family member",
            "The court or a professional server",
            "A friend of the applicant"
        ],
        "a": 2
    }
]
};
